function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Y from 'yjs';
import EventEmitter from 'eventemitter3';
import { WhiteboardPermissionFlag } from '../WhitePermissions';
import { WhiteboardKeys } from '../WhiteboardKeys';
import { removeDeepObserver } from '@netless/forge-room';
export class TrashedElementsModel extends EventEmitter {
  get hasDeleteSelfPermission() {
    return this.hasPermission(WhiteboardPermissionFlag.deleteSelf);
  }
  get hasDeleteOthersPermission() {
    return this.hasPermission(WhiteboardPermissionFlag.deleteOthers);
  }
  constructor(userManager, requestUserMap, hasPermission) {
    super();
    _defineProperty(this, "requestUserMap", void 0);
    _defineProperty(this, "userManager", void 0);
    _defineProperty(this, "hasPermission", void 0);
    _defineProperty(this, "observers", new Map());
    _defineProperty(this, "handleUserLeave", user => {
      if (user.id === this.userManager.selfId) {
        return;
      }
      const cb = this.observers.get(user.id);
      if (cb) {
        removeDeepObserver(this.requestUserMap(user.id), cb);
      }
    });
    _defineProperty(this, "handleUserJoin", user => {
      if (this.observers.has(user.id)) {
        const cb = this.observers.get(user.id);
        if (cb) {
          removeDeepObserver(this.requestUserMap(user.id), cb);
          this.observers.delete(user.id);
        }
      }
      const observer = evts => {
        this.handleUserTrashElementsChange(user.id, evts);
      };
      if (this.observers.has(user.id)) {
        removeDeepObserver(this.requestUserMap(user.id), this.observers.get(user.id));
      }
      this.requestUserMap(user.id).observeDeep(observer);
      this.observers.set(user.id, observer);
    });
    this.hasPermission = hasPermission;
    this.userManager = userManager;
    this.requestUserMap = requestUserMap;
    this.createModel(this.userManager.selfId);
    this.userManager.userIdList().forEach(userId => {
      const observer = evts => {
        this.handleUserTrashElementsChange(userId, evts);
      };
      if (this.observers.has(userId)) {
        removeDeepObserver(this.requestUserMap(userId), userId);
      }
      this.requestUserMap(userId).observeDeep(observer);
      this.observers.set(userId, observer);
    });
    this.userManager.on('join', this.handleUserJoin);
    this.userManager.on('leave', this.handleUserLeave);
  }
  handleUserTrashElementsChange(userId, evts) {
    for (const evt of evts) {
      if (evt.target.get('inner-map-id') === 'trashedElements') {
        const elementIds = Array.from(evt.target.keys()).filter(v => v !== 'inner-map-id');
        this.emit('elementsChange', userId, elementIds);
      }
    }
  }
  createModel(userId) {
    const userMap = this.requestUserMap(userId);
    if (!userMap.has('trashedElements')) {
      const ids = new Y.Map();
      ids.set('inner-map-id', 'trashedElements');
      userMap.set('trashedElements', ids);
    }
  }
  addTrashedElementForSelf(elementId, ownerId) {
    if (ownerId === this.userManager.selfId && !this.hasDeleteSelfPermission) {
      return;
    }
    if (ownerId !== this.userManager.selfId && !this.hasDeleteOthersPermission) {
      return;
    }
    if (!this.requestUserMap(this.userManager.selfId).has('trashedElements')) {
      return;
    }
    const ids = this.requestUserMap(this.userManager.selfId).get('trashedElements');
    for (const userId of this.userManager.userIdList()) {
      if (userId !== this.userManager.selfId) {
        const userMap = this.requestUserMap(userId);
        if (!userMap.has('trashedElements') || !userMap.has(WhiteboardKeys.selectElements)) {
          continue;
        }
        const trashedIds = this.requestUserMap(userId).get('trashedElements');
        const selectedIds = this.requestUserMap(userId).get(WhiteboardKeys.selectElements);
        if (selectedIds.has(elementId) || trashedIds.has(elementId)) {
          // 不能把别人选中的元素和删除中的元素删除
          return;
        }
      }
    }
    if (!ids.has(elementId)) {
      ids.set(elementId, elementId);
    }
  }
  removeAllTrashedElementsForSelf() {
    const ids = this.requestUserMap(this.userManager.selfId).get('trashedElements');
    this.emit('removeElementForSelf', this.userManager.selfId, Array.from(ids.keys()));
    ids.doc?.transact(() => {
      ids.clear();
      ids.set('inner-map-id', 'trashedElements');
    });
  }
  dispose() {
    for (const [key, value] of this.observers.entries()) {
      removeDeepObserver(this.requestUserMap(key), value);
    }
    this.observers.clear();
    this.userManager.off('leave', this.handleUserLeave);
    this.userManager.off('join', this.handleUserJoin);
  }
}